import React from 'react';
import { Link } from 'react-router-dom';
import { areas as canonicalAreasList } from '../../../data/areas';
import { getCanonicalAreaName, toArabicSlug } from '../../../data/areaSlugMapping';

const canonicalSet = new Set(canonicalAreasList);

/**
 * Shared Nearby Areas section — used by all 5 templates.
 * Renders `areaData.nearby` as clickable internal links when canonical,
 * or as informative local coverage tags if not a standalone page.
 * Critical for SEO internal linking structure.
 */
const NearbyAreas = ({ nearby, accentColor = '#0077ff' }) => {
  if (!nearby || nearby.length === 0) return null;

  return (
    <nav id="nearby-areas" aria-labelledby="nearby-heading" style={{
      background: 'white',
      borderRadius: '1.5rem',
      padding: '2rem',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      marginBottom: '2rem',
      border: `2px solid ${accentColor}22`,
      direction: 'rtl'
    }}>
      <h2 id="nearby-heading" style={{
        fontSize: '1.4rem',
        fontWeight: 800,
        color: '#0a2c61',
        marginBottom: '1.2rem',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem'
      }}>
        🗺️ مناطق مجاورة — ونش انقاذ قريب منك
      </h2>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.75rem',
        justifyContent: 'center'
      }}>
        {nearby.map((area, i) => {
          const canonical = getCanonicalAreaName(area);
          const isCanonical = canonical && canonicalSet.has(canonical);

          if (isCanonical) {
            return (
              <Link
                key={i}
                to={`/areas/${toArabicSlug(canonical)}`}
                style={{
                  background: `${accentColor}11`,
                  border: `1.5px solid ${accentColor}44`,
                  color: accentColor,
                  borderRadius: '2rem',
                  padding: '0.5rem 1.2rem',
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '1rem',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={e => {
                  e.currentTarget.style.background = accentColor;
                  e.currentTarget.style.color = 'white';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.background = `${accentColor}11`;
                  e.currentTarget.style.color = accentColor;
                }}
              >
                📍 ونش {canonical}
              </Link>
            );
          }

          return (
            <span
              key={i}
              style={{
                background: '#f1f5f9',
                border: '1.5px solid #cbd5e1',
                color: '#475569',
                borderRadius: '2rem',
                padding: '0.5rem 1.2rem',
                fontWeight: 600,
                fontSize: '0.95rem',
              }}
            >
              📍 {area}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default NearbyAreas;
